import * as React from "react";
import { TooltipApi } from "sb-resp-ui";
import { SubGroupConfiguration } from "../../../../data";
export class GroupingDropdown extends React.PureComponent {
    constructor(props) {
        super(props);
        this.filterBox = React.createRef();
        this.wrap = React.createRef();
        this.setTooltipMsg = TooltipApi.getInstance().setMessage.bind(this);
    }
    handleClick(event) {
        if (this.filterBox.current) {
            this.filterBox.current.classList.add("isHidden");
        }
    }
    componentDidMount() {
        window.addEventListener("click", this.handleClick.bind(this));
    }
    componentWillUnmount() {
        window.removeEventListener("click", this.handleClick);
    }
    /* istanbul ignore next */
    toggleOptions() {
        this.wrap.current && this.wrap.current.classList.toggle("rj-ev-list__gr-dropdown--active");
        this.filterBox.current && this.filterBox.current.classList.toggle("isHidden");
    }
    selectOption(ev, newOption) {
        this.toggleOptions();
        this.props.handler(newOption);
    }
    renderDesktopDropdown() {
        const tooltip = this.setTooltipMsg(`${this.props.dict.SortBy}`);
        return (React.createElement("div", { id: "rj-ev-list__gr-dropdown__wrap", className: "rj-ev-list__gr-dropdown__wrap", "data-uat": "div-ev-list-gr-dropdown-wrap", ref: this.wrap },
            React.createElement("label", Object.assign({ className: "rj-ev-list__gr-dropdown__label", onClick: ev => {
                    ev && ev.stopPropagation();
                    this.toggleOptions();
                }, "data-uat": "label-ev-list-gr-dropdown-label" }, tooltip),
                React.createElement("span", { className: "icon i-o-ev-filter i-14" })),
            React.createElement("div", { className: `rj-ev-list__gr-dropdown__options-holder isHidden`, "data-uat": "div-ev-list-gr-dropdown-options-holder", ref: this.filterBox },
                React.createElement("div", { className: "rj-ev-list__gr-dropdown__option rj-ev-list__gr-dropdown__option-league", onClick: (ev) => { ev && ev.stopPropagation(); this.selectOption(ev, SubGroupConfiguration.League); }, "data-uat": "div-ev-list-gr-dropdown-option-league" }, `${this.props.dict.SortBy} ${this.props.dict.League}`),
                React.createElement("div", { className: "rj-ev-list__gr-dropdown__option rj-ev-list__gr-dropdown__option-time", onClick: (ev) => { ev && ev.stopPropagation(); this.selectOption(ev, SubGroupConfiguration.Time); }, "data-uat": "div-ev-list-gr-dropdown-option-time" }, `${this.props.dict.SortBy} ${this.props.dict.Time}`))));
    }
    renderMobileDropdown() {
        return (React.createElement("div", { className: "rj-ev-list__gr-dropdown__wrap", "data-uat": "div-ev-list-gr-dropdown-wrap" },
            React.createElement("label", { className: "rj-ev-list__gr-dropdown__label", "data-uat": "label-ev-list-gr-dropdown-label" },
                React.createElement("span", { className: "icon i-o-ev-filter i-14" })),
            React.createElement("select", { className: `rj-ev-list__gr-dropdown__select`, onChange: ev => {
                    ev && ev.stopPropagation();
                    this.selectOption(ev, ev.target.value);
                }, defaultValue: this.props.subGroupBy, "data-uat": "select-ev-list-gr-dropdown-select" },
                React.createElement("option", { className: "rj-ev-list__gr-dropdown__select-option", "data-uat": "option-ev-list-gr-dropdown-select-option-league", value: SubGroupConfiguration.League }, `${this.props.dict.SortBy} ${this.props.dict.League}`),
                React.createElement("option", { className: "rj-ev-list__gr-dropdown__select-option", "data-uat": "option-ev-list-gr-dropdown-select-option-time", value: SubGroupConfiguration.Time }, `${this.props.dict.SortBy} ${this.props.dict.Time}`))));
    }
    render() {
        return (this.props.isDesktop
            ? this.renderDesktopDropdown()
            : this.renderMobileDropdown());
    }
}
//# sourceMappingURL=GroupingDropdown.js.map